import type {Coordinate} from "ol/coordinate";

export type CoordinateLonLat = {
    lon: number;
    lat: number;
};

export function toLonLat(coordinate: Coordinate): CoordinateLonLat {
    return {
        lon: coordinate[0],
        lat: coordinate[1],
    };
}

export function fromTypedLonLat({lon, lat}: CoordinateLonLat) {
    return [lon, lat]
}

export function formatTime(time: Date): string {
    return Intl.DateTimeFormat('ru-RU', {hour: 'numeric', minute: 'numeric'}).format(time);
}

export function assert(condition: unknown): asserts condition {
    if (!condition) {
        throw new Error("Assertion failed");
    }
}

export function map<T, R>(value: T | null, mapper: (_: T) => R): R | null {
    return value === null ? null : mapper(value);
}